import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiFormListComponent } from './fi-form-list.component';
import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { FiSideListNewModule } from '@fi-app/utilities/side-list-new/side-list-new.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { MatCardModule } from '@angular/material/card';
import { FiFormAnswerSetListComponent } from './fi-form-answer-set-list/fi-form-answer-set-list.component';

@NgModule({
    imports: [
        CommonModule,
        ItemsListModule,
        FiSideListNewModule,
        FiAppTextSharedModule,
        MatButtonModule,
        MatIconModule,
        FiItemsListModule,
        FiFormatDateModule,
        FiProfileIconModule,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
        FiWhenScrolledModule,
        FiLocalSearch2Module,
        MatCardModule,
    ],
    declarations: [FiFormListComponent, FiFormAnswerSetListComponent],
    exports: [FiFormListComponent],
})
export class FiFormListModule {}
